var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TinymceEditor',_vm._g(_vm._b({ref:"editor",attrs:{"value":_vm.value,"init":_vm.editorInit},on:{"onInit":_vm.onInit}},'TinymceEditor',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }